const BenefitCard = ({ icon, title, crossed = false }) => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-6">
        <div
          className="relative rounded-full flex items-center justify-center w-44 h-44 sm:w-52 sm:h-52 lg:w-56 lg:h-56"
          style={{
            backgroundColor: '#2f4c74'
          }}
        >
          {icon}
          {crossed ? (
            <>
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="block w-[70%] h-2 bg-red-500 rotate-45 rounded-full" />
              </span>
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="block w-[70%] h-2 bg-red-500 -rotate-45 rounded-full" />
              </span>
            </>
          ) : null}
        </div>
      </div>
      <div className="flex items-center justify-center" style={{ minHeight: '70px' }}>
        <h3 className="text-xl md:text-2xl font-normal" style={{ color: '#000' }}>
          {title}
        </h3>
      </div>
    </div>
  );
};

export default BenefitCard;
